import(/* webpackMode: "eager" */ "/home/interim/frontend/app/about/career/page.tsx");
